const principles = [
  { icon: "ri-time-line", title: "持续更新", desc: "每日刷新最新热点，让你不错过任何一个正在发酵的吃瓜事件。" },
  { icon: "ri-question-answer-line", title: "完整脉络", desc: "从起因到发酵再到反转，一个事件一个专题，把来龙去脉一次讲清楚。" },
  { icon: "ri-shield-check-line", title: "靠谱汇总", desc: "来源可溯、信息交叉核对，做让人放心的热点视频聚合与速递。" },
  { icon: "ri-community-line", title: "覆盖全面", desc: "明星、八卦、综艺、红人、社会热点五大栏目一网打尽。" },
];

const quotes = [
  { name: "追剧小李", text: "每天中午摸鱼刷一下吃瓜速递，今天的热点全都知道了，太方便了。" },
  { name: "八卦老八", text: "一个事件一个专题讲得特别全，省得我翻好几个平台拼拼凑凑。" },
  { name: "前排观众", text: "更新很及时，热搜刚爆就有视频汇总了，爱了爱了。" },
];

export default function Stats() {
  return (
    <section className="container-x py-12 md:py-16">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
            <i className="ri-heart-3-line"></i>
            我们坚持的事
          </span>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            为什么每天都有人来吃瓜速递
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600">
            我们不追求博眼球，只想把热闹的话题做得清楚、及时、好懂。以内容为核心，让每一位关注热点的人都看得明白、看得尽兴。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="card flex gap-3 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-600">
                  <i className={p.icon}></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{p.title}</h3>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600">
            <i className="ri-chat-quote-line"></i>
            用户怎么说
          </span>
          {quotes.map((q, idx) => (
            <figure key={q.name} className="card flex-1 p-5">
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-6 text-foreground-700">
                “{q.text}”
              </blockquote>
              <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                <span className={`flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700`}>
                  {q.name[0]}
                </span>
                {q.name}
                <span className="ml-auto text-foreground-400">#{idx + 1} 位收藏用户</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}